import { StyledButton } from "../../../components/ListShowButton";
import React, { FC } from "react";
import { useField } from "react-final-form";
import { cloneDeep, find } from "lodash";
import { useDispatch } from "react-redux";
import { changeSelectedRoute } from "../../../redux/navmode.action";

interface DetailRouteButtonProps {
  routeName: string;
  setIsOpenDetailRoute: any;
}

const DetailRouteButton: FC<DetailRouteButtonProps> = ({
  routeName,
  setIsOpenDetailRoute,
}) => {
  const dispatch = useDispatch();
  const routesField = useField("routes");

  const handleOpenDetailRoute = () => {
    // Deep clone using lodash
    const routesCopy = cloneDeep(routesField.input.value);

    // Find on the copy
    const findRoute = find(routesCopy, ["routeName", routeName]);

    setIsOpenDetailRoute(true);

    dispatch(changeSelectedRoute(findRoute));
  };

  return (
    <StyledButton variant="outlined" onClick={handleOpenDetailRoute}>
      Detail Route
    </StyledButton>
  );
};

export default DetailRouteButton;
